function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawSpeechToText = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 804.887 802.861",
    style: style
  }, props), React.createElement("path", {
    d: "M788.056 298.167C744.77 127.951 595.196 5.078 419.631.15c-92.816-2.605-190.484 28.178-261.594 135.898-127.117 192.563 7.811 325.63 101.88 388.86a588.61 588.61 0 0 1 121.663 109.35c63.54 75.401 185.777 169.097 331.355 22.29 105.515-106.405 103.955-245 75.121-358.38z",
    fill: "#f2f2f2"
  }), React.createElement("ellipse", {
    cx: 392,
    cy: 753.361,
    rx: 392,
    ry: 49.5,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 392,
    cy: 744.139,
    rx: 348,
    ry: 34.722,
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M199.754 450.448h20.43v310.535h-20.43z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M381.58 442.276v8.172l-333.007 4.086v-8.172l.47-.307 58.777-38.51h247.201l26.559 34.731z"
  }), React.createElement("path", {
    d: "M322.334 393.244s-73.548 6.13-49.032 24.516 49.032-12.258 49.032-12.258z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M381.58 442.521v7.927l-333.007 4.086v-8.172l.47-.307 332.537-3.534z"
  }), React.createElement("path", {
    d: "M432.655 293.138l1.789-6.707s-24.262 43.48-26.305 47.566-36.774 38.817-40.86 44.946a41.74 41.74 0 0 1-10.215 10.215h-38.816s-8.172 26.56 4.086 28.602 51.074 10.215 59.246 10.215 59.247-46.989 59.247-46.989z",
    fill: "#575a89"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M440.827 589.371l-12.258 171.611h12.258l14.301-175.697-14.301 4.086zM589.965 568.941l-12.258 171.611h12.258l14.301-175.697-14.301 4.086zM612.438 589.371L600.18 760.982h12.258l14.301-175.697-14.301 4.086zM422.44 573.027l-12.258 171.611h12.258l14.301-175.697-14.301 4.086z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M659.427 354.427l-34.731 249.245-206.342-8.172 1.389-23.004 2.697-44.415 159.353 8.172 26.559-181.826h51.075z"
  }), React.createElement("path", {
    d: "M659.427 354.427l-34.73 249.245-206.343-8.172 1.39-23.004c43.066 1.655 188.608-7.64 188.608-7.64 0-32.607 28.643-160.253 40.206-210.429z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M297.818 656.79s-6.13 46.989-18.387 55.16 51.075 18.388 51.075 18.388l4.086-61.29zM504.16 677.22s10.215 12.258 12.258 20.43 32.688 12.258 32.688 12.258l22.472-24.516s-28.601-24.516-36.773-24.516-30.645 16.344-30.645 16.344z",
    fill: "#ffb9b9"
  }), React.createElement("circle", {
    cx: 450.021,
    cy: 206.311,
    r: 49.032,
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M436.741 240.02s24.516 46.989 20.43 55.16 53.118-38.816 53.118-38.816-20.43-32.688-20.43-42.903-53.118 26.559-53.118 26.559z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M459.214 481.093s-157.31-24.516-163.44 32.688-28.601 130.75-30.644 136.88 67.419 40.86 75.59 28.602 22.473-110.322 18.387-118.494-6.129-18.387 2.043-16.344 98.064 20.43 116.45 14.301 65.377-87.848 65.377-87.848z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M459.214 481.093s-157.31-24.516-163.44 32.688-28.601 130.75-30.644 136.88 67.419 40.86 75.59 28.602 22.473-110.322 18.387-118.494-6.129-18.387 2.043-16.344 98.064 20.43 116.45 14.301 65.377-87.848 65.377-87.848z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M455.128 468.835l6.129 51.075s-98.064 36.773-61.29 96.02 77.634 91.935 77.634 91.935 65.376-36.774 65.376-46.99-79.677-67.418-69.462-67.418 157.31-8.172 126.665-89.891-145.052-34.731-145.052-34.731zM295.775 713.994s-16.344-18.387-16.344-14.301-46.989 28.602-55.16 30.645-20.43 6.129-4.087 12.257 120.537 8.172 120.537 4.086 4.086-42.902-4.086-38.816-38.817 14.3-40.86 6.129zM536.848 699.693s-22.473-6.13-24.516 0-4.086 30.645-22.473 38.817-24.516 20.43 0 22.472 91.934-44.945 91.934-53.117-8.172-32.688-12.258-30.645-14.3 20.43-32.687 22.473z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M162.98 726.252h93.978v36.774H162.98z"
  }), React.createElement("path", {
    d: "M510.289 244.106s-7.647-20.45-21.189-8.182-40.101 42.913-40.101 42.913-16.344 6.129-22.473 16.344-6.129 77.633 6.13 100.106 12.257 61.29 16.343 71.505 0 20.43 14.301 20.43-8.172-16.344 38.817 0 100.106 36.774 104.192 22.473-6.129-22.473 0-28.602 0-8.172-4.086-22.473-8.172-16.344-10.215-34.731 0-36.774-4.086-44.946-4.086-20.43-4.086-40.86-12.258-61.29-34.73-73.547-38.817-20.43-38.817-20.43z",
    fill: "#575a89"
  }), React.createElement("path", {
    d: "M402.146 151.789c11.388-11.117 23.357-22.592 38.517-27.434 20.235-6.462 42.793.32 60.213 12.474 3.758 2.622 7.438 5.591 9.697 9.579 2.071 3.657 2.796 7.902 3.452 12.054 2.313 14.62 4.209 29.437 3.078 44.196s-5.483 29.594-14.572 41.277a85.243 85.243 0 0 1-18.162-29.92c-1.034-2.943-1.964-6.045-4.054-8.361s-5.769-3.563-8.392-1.874c-3.645 2.346-3.187 8.612-7.036 10.607a6.695 6.695 0 0 1-4.206.44c-10.033-1.728-13.527-14.02-20.057-21.832-9.624-11.513-23.1-10.785-36.252-14.093-15.263-3.84-11.484-18.077-2.226-27.113z",
    fill: "#2f2e41"
  }), React.createElement("ellipse", {
    cx: 319.172,
    cy: 419.511,
    rx: 41.996,
    ry: 9.13,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M315.725 420.535l-.822-43.47c-.183-9.724.164-20.746 7.394-27.252 4.568-4.111 11.437-5.879 14.303-11.315 1.561-2.962 1.59-6.463 1.584-9.811l-.115-59.17",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), React.createElement("rect", {
    x: 327.085,
    y: 250.92,
    width: 19.476,
    height: 37.735,
    rx: 8,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M392.92 410.951s-67.713-17.96-73.236-2.511 57.81 29.75 57.81 29.75h26.56z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M534.805 276.794s-30.645 22.473-38.817 55.16-14.301 67.42-14.301 67.42l-93.978 12.257s-8.172 32.688 4.086 34.73 104.193 8.173 118.494 0 63.332-110.32 61.29-120.536-6.13-46.988-36.774-49.031z",
    fill: "#575a89"
  }), React.createElement("path", {
    d: "M168.556 422.058l33.196 2.664 47.335-3.074-.824-.078-43.847-4.225c-10.04-3.688-3.074-25.41-3.074-25.41l-33.597 1.71-2.672.135c-11.885 27.868 3.483 28.278 3.483 28.278z",
    fill: "#d1d9ec"
  }), React.createElement("path", {
    d: "M168.556 422.058l33.196 2.664 47.335-3.074-.824-.078-47.843 1.718-32.069-3.484c-9.098-2.393-3.89-18.192-.606-26.16l-2.673.136c-11.884 27.868 3.484 28.278 3.484 28.278z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M113.536 223.698l9.942 144.16v17.4c.303 4.372 2.382 11.985 6.767 11.956l8.146-6.986h146.646c2.524-.016-5.964-3.701-6.214-6.214l10.284-5.369-10.762-105.707a8.81 8.81 0 0 0-5.877-7.43l-145.69-50.45c-4.959-1.717-10.004-1.106-13.16 1.517-2.163 1.8-.332 3.533-.082 7.123z",
    fill: "#4c4c56"
  }), React.createElement("path", {
    d: "M120.578 370.375l1.332 19.114a8.298 8.298 0 0 0 8.335 7.725l3.082-.02 152.858-.926a4.288 4.288 0 0 0 4.237-4.713l-1.315-12.91z",
    fill: "#dfe6f5"
  }), React.createElement("ellipse", {
    cx: 223.063,
    cy: 386.198,
    rx: 2.049,
    ry: 4.098,
    fill: "#fff"
  }), React.createElement("path", {
    d: "M148.23 426.853s-41.803-15.779-53.073-4.304c0 0-1.844 3.484 5.737 4.304l30.636 2.459s12.601 1.23 16.7-2.46z",
    fill: "#d1d9ec"
  }), React.createElement("path", {
    d: "M147.114 422.748c-8.212-3.354-32.932-12.035-48.747-2.43 0 0 17.5-1.94 27.117 3.62s22.746 2.915 22.746 2.915l.196-.35a2.652 2.652 0 0 0-1.312-3.755zM110.43 224.71l11.48 164.78a8.298 8.298 0 0 0 8.335 7.724l3.082-.02a29.507 29.507 0 0 1-5.344-6.897s-11.27-165.57-12.09-169.669a8.345 8.345 0 0 0-2.274-4.053 9.281 9.281 0 0 0-3.189 8.135z",
    fill: "#dfe6f5"
  }), React.createElement("path", {
    d: "M110.43 224.71l11.48 164.78a8.298 8.298 0 0 0 8.335 7.724l3.082-.02a29.507 29.507 0 0 1-5.344-6.897s-11.27-165.57-12.09-169.669a8.345 8.345 0 0 0-2.274-4.053 9.281 9.281 0 0 0-3.189 8.135z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M174.97 304.136a104.03 104.03 0 0 1-18.357 9.339c-4.144 1.614-8.703 2.972-12.981 1.757s-7.788-6.012-6.08-10.119a7.54 7.54 0 0 1 6.212-4.26 13.347 13.347 0 0 1 7.58 1.796 22.166 22.166 0 0 1 9.592 10.179c1.027 2.226 1.763 4.74 3.659 6.294a11.946 11.946 0 0 0 5.18 2.015c4.35.943 8.814 1.892 13.216 1.237s8.798-3.266 10.281-7.462M210.045 286.647q-1.257 19.807-4.09 39.471l9.506-.93c3.504-.342 7.513-.986 9.352-3.988 1.714-2.8.663-6.621-1.557-9.04s-5.347-3.756-8.373-5.026l-4.958-2.08M259.13 305.68c-3.37-.778-6.812-1.543-10.258-1.238s-6.958 1.851-8.796 4.782c-3.396 5.412.404 12.793 5.742 16.304a23.207 23.207 0 0 0 15.034 3.658",
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }));
};

UndrawSpeechToText.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawSpeechToText;